import React from 'react';
import './Footer.css'
import whiteLogo from '../../img/logo-white.png'
import phone from '../../img/phone-icon.jpg'
import email from '../../img/email-icon.png'
import faceboook from '../../img/facebook-icon.png'
import twitter from '../../img/twitter-icon.png'
import tiktok from '../../img/tiktok-icon.png'
import youtube from '../../img/youtube-icon.png'

const Footer = () => {
    return (
        <div className='footer'>
            <div>
                <img className='white_logo' src={whiteLogo} alt="logo" />
                <p className='footer_about'>شركة متخصصة في بيع المنتجات الالكترونية وكل ما يخص عالم التكنولوجيا والاجهزة الحديثة في جميع انحاء العالم مع خدمات توصيل في كل ارجاء الوطن العربي واسعار تنافسية.</p>
            </div>
            <div>
                <h2>الفئات</h2>
                <div className='catogery_container'>
                    <div>
                        <p>● الشواحن</p>
                        <p>● السماعات</p>
                        <p>● الهاند فري</p>
                        <p>● الباور بانك</p>
                        <p>● ساعات سمارت</p>
                    </div>
                    <div>
                        <p>● اكسسوارات الالعاب</p>
                        <p>● الهواتف</p>
                        <p>● احدث الاكسسوارات الذكية</p>
                        <p>● اكسسوارات الكمبيوتر</p>
                        <p>● اقوي العروض</p>
                    </div>
                </div>
            </div>
            <div>
                <h2>تواصل معنا</h2>
                <img className='footer_img' src={phone} alt="phone" />
                <p className='info'>الهواتف: 01555725512-01150931015</p><br />
                <img className='footer_img' src={email} alt="email" />
                <p className='info'>البريد الالكتروني: techjanet1@gmail.com</p>
                <div className="social_icon">
                    <a href="https://www.facebook.com/profile.php?id=100088439904626"><img src={faceboook} alt="faceboook" /></a>
                    <img src={twitter} alt="twitter" />
                    <a href="https://www.tiktok.com/@techjanet"><img src={tiktok} alt="tiktok" /></a>
                    <img src={youtube} alt="youtube" />
                </div>
            </div>
        </div>
    );
}

export default Footer;
